import type { State } from '../../types';
import { getEntities } from '../entities';

export const getCardOrder = (state: State) => getEntities(state).cardOrder;
export const getCardOrderGlobal = (state: State) => getEntities(state).cardOrderGlobal;
export const getCardOrderByCardlistId = (state: State, cardListId: string) =>
	getCardOrder(state)[cardListId];
